import PropTypes from 'prop-types';
import BarList from './BarList';

const CostCompositionPanel = ({ rows, unit }) => {
  if (!rows || rows.length === 0) {
    return null;
  }

  return (
    <BarList
      title="Cost composition"
      subtitle="The levelized cost broken down by category (capital, feedstock, operating, taxes, …), shown as each one's share of the total."
      items={rows}
      valueUnit={unit}
      valueDigits={2}
    />
  );
};

CostCompositionPanel.propTypes = {
  rows: PropTypes.array,
  unit: PropTypes.string,
};

export default CostCompositionPanel;
